<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="export()"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">
    <div class="main-container">
        <div class="export-info-container"  [attr.data-automation-id]="modalAutomationId + '-export-info-label'">{{documentCountText}}</div>
        <div class="header">Export to</div>
        @if (isRelativityProject()) {
            <div class="relativity-prj-container">
                <label requiredAsterisk>Review Project:</label>
                <select class="review-project-select" 
                    [attr.data-automation-id]="modalAutomationId + '-review-project-select'" [(ngModel)]="selectedReviewProjectId">
                    <option *ngFor="let reviewProj of availableRelativityProjects" [ngValue]="reviewProj.reviewProjectId">{{reviewProj.reviewProjectName}}</option>
                </select>
            </div>
        }
        <div class="folder-container" [ngClass]="{'reef-review': isReefReviewProject}">
            <div class="folder-button" [ngClass]="{'reef-review': isReefReviewProject, 'relativity-button': isRelativityProject()}">
                <label [ngClass]="{'disabled': createReviewFolder, 'reef-review-label': isReefReviewProject}"
                    requiredAsterisk [isDisabled]="createReviewFolder">Document
                    Folder: </label>
                <button [disabled]="createReviewFolder" [attr.data-automation-id]="modalAutomationId + '-document-folder-button'"
                    class="secondary-button btn-action document-folder-btn" (click)="openDocumentFolderModal()" [title]="documentFolderPath">
                    <i class="fa fa-folder-open color-blue-01"></i>
                    <span [ngClass]="{'overflow-path-span': isFolderPathSelected}">
                        {{ documentFolderPath }}
                    </span>
                </button>
            </div>
            @if (isReefReviewProject) {
                <div class="review-backslash-label">
                    <label>\</label>
                </div>
            
                <div class="volume-checkbox-section" [ngClass]="{'bg-highlight': createReviewFolder}">
                    <div class="export-name">
                        <res-custom-checkbox [automationId]="modalAutomationId + '-create-review-folder'"
                            [(ngModel)]="createReviewFolder" (ngModelChange)="onCreateFolderChanged()"></res-custom-checkbox>
                        <label [ngClass]="{'disabled': !createReviewFolder}" class="export-name-label">Export Name</label>
                    </div>
                    <div class="export-row-column-auto">
                        <label></label>
                        <label class="label-with-top-margin" [ngClass]="{'disabled': !createReviewFolder}">\</label>
                    </div>
                    <div class="export-row-column-auto">
                        <label requiredAsterisk [isDisabled]="!createReviewFolder" class="volume-label"
                            [ngClass]="{'disabled': !createReviewFolder}">Volume Label: </label>
                        <input type="text" [disabled]="!createReviewFolder" class="volume-input"
                            [(ngModel)]="volumeLabelValue" [attr.data-automation-id]="modalAutomationId + '-volume-label-input'">
                    </div>
                    <div class="export-row-column-auto">
                        <label [ngClass]="{'disabled': !createReviewFolder}">Volume #:</label>
                        <label class="label-small-margin" [ngClass]="{'disabled': !createReviewFolder}">0001<label class="label-left-margin"
                                [ngClass]="{'disabled': !createReviewFolder}">\</label></label>
                    </div>
                </div>
            } @else {
                <div class="column-auto">
                    <label>\ ... \</label>
                </div>
            }
            <div class="folder-by-container" [ngClass]="{'reef-review': isReefReviewProject}">
                <label>Folder by (optional): </label>
                <select [attr.data-automation-id]="modalAutomationId + '-folder-by-optional'"
                    [(ngModel)]="folderByMetadataField">
                    <option *ngFor="let folderByOption of folderByOptions" [ngValue]="folderByOption">
                        {{ folderByOption }}</option>
                </select>
            </div>
        </div>
    </div>
</res-base-modal>
